module.exports = __webpack_public_path__ + "img/sillon.045481b1.svg";